module.exports = __webpack_public_path__ + "static/media/speed.10fd54f1.png";